import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

export type CodeTone = 'neutral' | 'accent' | 'violet';

const TONES: Record<CodeTone, string> = {
  neutral: styles.codeNeutral,
  accent: styles.codeAccent,
  violet: styles.codeViolet,
};

/**
 * Техническое значение, которое читают по буквам: снимок строки журнала,
 * ключ настройки, сырое значение переключателя.
 *
 * Своя подложка обязательна — та, что была раньше, совпадала по цвету с
 * карточкой, и JSON на ней терялся.
 *
 * С `label` получается строка из макета: подпись слева, значение справа,
 * засечка в цвете тона. Ею набраны «было / стало» в журнале — серая засечка у
 * прошлого, бирюзовая у нового. Друг под другом два блока с заголовками
 * читались вдвое длиннее и не показывали, что это ОДНА пара.
 */
export function Code({
  label,
  note,
  tone = 'neutral',
  children,
}: {
  label?: string;
  /**
   * Приписка у ПРАВОГО края той же полосы: «умолчание» у ключа, который в
   * базе не лежит. Снаружи она вставала отдельной подписью и читалась как
   * примечание ко всей карточке, а относится к самому значению.
   */
  note?: ReactNode;
  tone?: CodeTone;
  children: ReactNode;
}) {
  if (label === undefined) {
    if (note === undefined) {
      return <code className={clsx(styles.code, TONES[tone])}>{children}</code>;
    }
    return (
      <div className={clsx(styles.code, styles.codeNoted, TONES[tone])}>
        <code className={styles.codeValue}>{children}</code>
        <span className={styles.codeNote}>{note}</span>
      </div>
    );
  }

  return (
    <div className={clsx(styles.codeRow, TONES[tone])}>
      <span className={styles.codeLabel}>{label}</span>
      <code className={styles.codeValue}>{children}</code>
      {note === undefined ? null : <span className={styles.codeNote}>{note}</span>}
    </div>
  );
}
